import React from "react";
import * as FaIcons from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import "aos/dist/aos.css";
import "../../pages/Landing/Home.css";

const Footer = () => {
  return (
    <>
      <div className="bg-[#e9e9e9] dark:bg-[#092c44] h-fit py-4 flex flex-col items-center justify-center mt-[30px] dark:text-zinc-200 text-slate-800">
        <div className="h-fit flex flex-col gap-2 items-center footer">
          <h1 className="text-center text-[35px]">Follow me:</h1>
          <div className="w-fit mx-auto flex gap-5 items-center">
            <Tooltip title="Discord" arrow>
              <a
                href="https://discord.com/users/1071075450710933616"
                target="_blank"
                className="grow p-2 w-fit aspect-square bg-slate-400 rounded-[50%] border-[1px] border-slate-300"
              >
                <FaIcons.FaDiscord
                  className={`cursor-pointer text-[#ffffff] text-[20px]`}
                />
              </a>
            </Tooltip>
            <Tooltip title="Linkedin" arrow>
              <a
                href="https://www.linkedin.com/in/gerard-valentin-rutayisire-manzi-b79631234/"
                target="_blank"
                className="grow p-2 w-fit aspect-square bg-slate-400 rounded-[50%] border-[1px] border-slate-300"
              >
                <FaIcons.FaLinkedinIn
                  className={`cursor-pointer text-[#ffffff] text-[20px]`}
                />
              </a>
            </Tooltip>
            <Tooltip title="Github" arrow>
              <a
                href="https://github.com/gerard1001"
                target="_blank"
                className="grow p-2 w-fit aspect-square bg-slate-400 rounded-[50%] border-[1px] border-slate-300"
              >
                <FaIcons.FaGithub
                  className={`cursor-pointer text-[#ffffff] text-[20px]`}
                />
              </a>
            </Tooltip>
          </div>
          <h1>Copyright © 2023, GERARD.</h1>
        </div>
      </div>
    </>
  );
};

export default Footer;
